import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

interface ArticulosComponentProps {
  newsForCategories: any;
}

declare const window: any;
const ArticulosComponent: React.FC<ArticulosComponentProps> = ({
  newsForCategories,
}) => {
  return (
    <div className="articulos">
      <div className="title">Lee más artículos</div>
      <div className="contenido row justify-content-center">
        <div className="col-lg-6 col-sm-12">
          <Link
            to={`/noticias/${newsForCategories[0]?.category_id}/${newsForCategories[0]?.slug}`}
            className="left"
          >
            <img src={`https://manager.hyundaicolombia.co/${newsForCategories[0]?.media?.url}`} alt="" />
            <div className="title">{newsForCategories[0]?.title}</div>
            <div className="category">{newsForCategories[0]?.category}</div>
            <Link
              to={`/noticias/${newsForCategories[0]?.category_id}/${newsForCategories[0]?.slug}`}
              className="readMore"
            >
              Leer más
            </Link>
          </Link>
        </div>
        <div className="col-lg-6 col-sm-12">
          <div className="right">
            <div className="noticia row">
              {newsForCategories?.map((item: any, index: number) =>
                index === 0 ? null : (
                  <>
                    <Link
                      to={`/noticias/${item?.category_id}/${item?.slug}`}
                      className="col-lg-6 col-sm-12 mb-4"
                    >
                      <img src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} alt="" />
                    </Link>
                    <Link
                      to={`/noticias/${item?.category_id}/${item?.slug}`}
                      className="col-lg-6 col-sm-12 mar"
                    >
                      <div className="title">{item?.title}</div>
                      <div className="category">{item?.category}</div>
                      <Link
                        to={`/noticias/${item?.category_id}/${item?.slug}`}
                        className="readMore"
                      >
                        Leer más
                      </Link>
                    </Link>
                  </>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      <Link to={"/noticias"} className="all-news">
        Conoce todos los artículos
      </Link>
    </div>
  );
};

export default ArticulosComponent;
